export const GACategory = {
  farmSummaries: "Farm Summaries"
};

export const GAAction = {
  makeFarmSummary: "Make farm summary"
};
